<template>
  <BaseButton type="shade" @click="onShare" class="share-button">
    <BaseSvgIcon name="share" class="icon" />
    {{ $t("ShareIt") }}
  </BaseButton>
</template>

<script setup>
import { computed } from "vue";
import { BaseButton, BaseSvgIcon } from "@/shared/ui";
import { useStore } from "vuex";

const store = useStore();

const getUserData = computed(() => store.getters["user/getUserData"]);

const getIsTransactionPage = () => {
  if (window.location.href.includes("transaction")) {
    return "tx_share";
  } else {
    return "address_share";
  }
};

const getUserId = () => {
  if (getUserData.value) {
    return getUserData.value.userData.user_id;
  }
  return null;
};

const onShare = async () => {
  try {
    await navigator.share({
      title: "Address",
      text: `${window.location.href}?utm_source=share&utm_medium=explorer&utm_campaign=${getIsTransactionPage()}&referrer=${getUserId()}`,
    });
  } catch (err) {
    console.error("Error sharing:", err);
  }
};
</script>

<style lang="scss" scoped>
.share-button {
  background: #232323;
  height: 36px;
  display: flex;
  align-items: flex-end;
  padding: 10px 18px 10px 10px;
  gap: 8px;
  font-weight: 500;
  border-radius: 10px;
  line-height: 13px;
}
.icon {
  width: 16px;
  height: 16px;
}
</style>
